

(function ($) {
    'use strict';
    $.fn.selectAll = function (options, initCheckboxesCallback, changeCallback) {
        return this.each(function () {
            const self = $(this);
            // Default settings
            var settings = $.extend({
                target: self.attr( '[data-target]' )
			}, options );

		 	const isAllChecked = function() {
				let inputChecked = true;

				$( `${settings.target}:not(:checked)` ).each(function(){
					inputChecked = false;
					return false;
				});

				return inputChecked;
			};

			self.on("change.selectAll", function () {
				var isChecked = $(this).prop( 'checked' );

				$( settings.target ).prop( 'checked', isChecked );

                if (changeCallback) {
                    changeCallback();
                }
			});

			$( settings.target ).on( 'change.selectAll', function() {
				var isChecked = $(this).prop( 'checked' );

				if ( !isChecked ) {
					self.prop( 'checked', false );
				}

				if( isAllChecked() ) {
					self.prop( 'checked', true );
				}

                if (changeCallback) {
                    changeCallback();
                }
            });

            if (initCheckboxesCallback) {
                initCheckboxesCallback();
            } else {
                $(settings.target).prop('checked', true);
            }
            self.prop('checked', isAllChecked());
        });
    }
})(jQuery);
